import { IRegisterUser } from './../../../models/registration/register';
import { ILinkSettings } from 'src/app/models/app-config.model';
import { Features } from 'src/app/models/features';
import { RegistrationFacade } from './../../../store/registration/facade/registration.facade';
import { AppConfig } from 'src/app/app.config';
import { LookupType } from './../../../models/lookups/lookups';
import { Subscription, Observable } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { OnDestroy, OnInit, Component } from '@angular/core';
import * as entityLegalTypeLookups from 'src/app/models/lookups/entityLegalTypeLookup';
import { IRegistrationSettings } from 'src/app/models/featuresConfig';
@Component({
    selector: "app-default-register",
    templateUrl: "./register-default.component.html",
    styleUrls: ['./register-default.component.scss']
})
export class RegisterDefaultComponent implements OnInit, OnDestroy {
    // Form elements
    registerForm: UntypedFormGroup;
    accountType: UntypedFormControl;
    firstName: UntypedFormControl;
    lastName: UntypedFormControl;
    email: UntypedFormControl;
    password: UntypedFormControl;
    tandc: UntypedFormControl;
    registrationSubscription: Subscription;

    // Restrict lookup to those in config
    entityLegalTypes: Array<LookupType>;

    // Links
    contactUs: string;
    termsOfUse: string;
    privacyPolicy: string;
    isDisabled = false;

    hide = true;
    registerFailText$: Observable<string> = this.facade.failtext$;


    constructor(
        private appConfig: AppConfig,
        private facade: RegistrationFacade
    ) {
        const featureConfig: IRegistrationSettings = this.appConfig.getSection(
            Features.REGISTRATION
        );

        if (featureConfig) {
            this.entityLegalTypes = entityLegalTypeLookups.EntityLegalTypeLookup.filter(
                x =>
                    !featureConfig.signUpTypes ||
                    featureConfig.signUpTypes.includes(x.value)
            );
        }
    }

    ngOnInit() {
        this.createFormControls();
        this.createForm();
        this.isDisabled = false;
        const links: ILinkSettings = this.appConfig.getLinks();
        this.contactUs = links.contactUs;
        this.termsOfUse = links.termsOfUse;
        this.privacyPolicy = links.privacyPolicy;
        this.registrationSubscription = this.facade.state$.subscribe(status => {
            // re-enables the register button once the error message appears
            if (status.failText && status.failText.length > 0) {
                this.isDisabled = false;
            }
        });
    }

    createFormControls() {
        const re: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d~!@#\$%\^&\*_+=`|(){}[\]:;"\'<>,.?/-])[a-zA-Z\d~!@#\$%\^&\*_+=`|(){}[\]:;"\'<>,.?/-]+$/;

        this.accountType = new UntypedFormControl(
            this.entityLegalTypes.find(x => x.key === "Individual").value,
            Validators.required
        );
        this.firstName = new UntypedFormControl("", Validators.required);
        this.lastName = new UntypedFormControl("", Validators.required);
        this.email = new UntypedFormControl("", [Validators.required, Validators.email]);
        this.password = new UntypedFormControl("", [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(re.source)
        ]);
        this.tandc = new UntypedFormControl(false, Validators.required);
    }

    createForm() {
        this.registerForm = new UntypedFormGroup({
            accountType: this.accountType,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            password: this.password,
            tandc: this.tandc
        });
    }

    onSubmit() {
        // Ensure that if we have no terms / policy to agree to, accept.
        let tandcValue = this.tandc.value;
        if (!this.termsOfUse && !this.privacyPolicy) {
            tandcValue = true;
        }

        this.isDisabled = true;
        const values: IRegisterUser = {
            investorType: this.accountType.value,
            firstName: this.firstName.value,
            lastName: this.lastName.value,
            email: this.email.value,
            password: this.password.value,
            managerEntityId: Number(this.appConfig.getEnvironment().managerEntityId),
            acceptTerms: this.tandc.value,
            siteId: Number.parseInt(this.appConfig.getEnvironment().siteId, 10)
        };

        this.facade.register(values);
    }

    ngOnDestroy(): void {
        this.registrationSubscription.unsubscribe();
    }
}
